<template>
  <li class="list-group-item" :class="classNames">
    <div class="list-group-check">
      <div class="task-actions">
        <div class="task-actions-item" v-if="onBulkFlag">
          <label class="checkbox">
            <input
              :id="`select-task-${activeTaskId}`"
              type="checkbox"
              @change="onCheck"
            />
            <span class="checkbox-text"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="list-group-text">
      <!-- アンケートは別タブで開かない -->
      <p v-if="url !== '' && linkType == 3 && !isUnavailable">
        <router-link :to="url" v-html="name"></router-link>
      </p>
      <p v-else-if="url !== '' && !isUnavailable">
        <a :href="url" class="link-external" target="_blank" v-html="name"></a>
      </p>
      <p v-else v-html="name"></p>
    </div>
    <div class="list-group-control">
      <div class="task-actions">
        <div class="task-actions-item">
          <label :for="`complete-task-${activeTaskId}`" class="checkbox">
            <input
              :id="`complete-task-${activeTaskId}`"
              :checked="isComplete"
              @input="toggleComplete"
              type="checkbox"
              :disabled="isDisabled || onBulkFlag"
            />
            <span class="checkbox-text"></span>
          </label>
        </div>
        <div class="task-actions-item" v-if="hasMenu">
          <WaveButton
            type="button"
            size="small"
            :text="true"
            :disabled="onBulkFlag"
            @click.stop="toggleTaskMenu"
          >
            <i class="fas fa-ellipsis-v"></i>
          </WaveButton>
        </div>
        <div
          class="task-actions-item is-locked"
          v-if="isLocked && !isUnavailable"
        >
          <i class="fas fa-lock"></i>
        </div>
        <div
          class="task-actions-item"
          :class="[isUnavailable && !onBulkFlag ? 'is-link' : 'is-locked']"
          @click="onRevert"
          v-if="isUnavailable"
        >
          元に戻す
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        class="list-group-popup popup"
        :class="{ 'is-active': isMenuOpen }"
        v-if="isMenuOpen"
      >
        <ul class="popup-menu">
          <li class="popup-menu-item" @click.stop="toEdit">編集する</li>
          <li class="popup-menu-item" @click.stop.prevent="onDelete">
            削除する
          </li>
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  props: {
    stepId: {
      type: Number,
      required: true
    },
    taskId: {
      type: Number,
      required: true
    },
    taskStatusId: {
      type: Number,
      required: true
    },
    taskTypeId: {
      type: Number,
      required: true
    },
    revision: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    isComplete: {
      type: Boolean,
      required: true
    },
    isUnavailable: {
      type: Boolean,
      required: true
    },
    isLocked: {
      type: Boolean,
      required: true
    },
    isMenuOpen: {
      type: Boolean,
      required: true
    },
    bulkFlag: {
      type: Boolean,
      default: false,
      required: false
    },
    linkType: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      isOpen: false,
      isLoading: false,
      all: false,
      isChecked: false,
      taskStatusList: {
        task_status_id: [],
        task_id: [],
        revision: []
      }
    }
  },

  computed: {
    classNames() {
      return {
        'is-done': this.isComplete && !this.isUnavailable,
        'is-disabled': this.isUnavailable
      }
    },
    activeTaskId() {
      return this.taskId === 0 ? this.taskStatusId : this.taskId
    },
    isPlanner() {
      return this.$store.getters['auth/isPlanner']
    },
    isCustomer() {
      return this.$store.getters['auth/isCustomer']
    },
    isDisabled() {
      return this.isUnavailable || this.isLoading
    },
    hasMenu() {
      const available = !this.isUnavailable 
      return this.isCustomer ? available && !this.isLocked : available
    },
    hasStatus() {
      return this.taskStatusId !== 0
    },
    emitParams() {
      return [this.taskId, this.taskStatusId, this.taskTypeId, this.clearLoad]
    },
    onBulkFlag() {
      return this.bulkFlag
    }
  },

  methods: {
    toggleTaskMenu() {
      this.$emit('toggleMenu', !this.isMenuOpen)
    },
    toggleComplete() {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      this.$emit('complete', ...this.emitParams)
    },
    onDelete() {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      this.$emit('delete', ...this.emitParams)
    },
    onRevert() {
      if (!this.onBulkFlag) {
        this.$emit('revert', ...this.emitParams)
      }
    },
    toEdit() {
      const name = this.hasStatus ? 'step.task-status.edit' : 'step.task.edit'
      const id = this.hasStatus ? this.taskStatusId : this.taskId
      this.$wcRouter.push({ name, params: { taskId: id, stepId: this.stepId } })
    },
    clearLoad() {
      this.isLoading = false
    },
    onCheck() {
      this.taskStatusList.task_status_id = this.taskStatusId
      this.taskStatusList.task_id = this.taskId
      this.taskStatusList.revision = this.revision
      this.$emit('check', this.taskStatusList)
    },
  }
}
</script>
